import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IpServiceService {
  constructor(private http: HttpClient) {}

  public getIPAddress(): Observable<any> {
    const params = new HttpParams().set('format', 'json');
    return this.http.jsonp('https://api.ipify.org', 'callback').pipe(
      map((response: any) => {
        return response;
      })
    );
  }
}
